import React from 'react';

export function DisabledTitleWrapper({
    children,
    disabledTitle,
    isEnabled,
}: {
    children: React.ReactElement;
    disabledTitle?: string;
    isEnabled: boolean;
}): React.ReactElement {
    return !isEnabled && disabledTitle ? (
        // Disabled Radix/Arc menu items can suppress normal pointer hover behavior,
        // so a native title must live on an enabled wrapper around the disabled item.
        <div style={{ display: 'block', width: '100%' }} title={disabledTitle}>
            {children}
        </div>
    ) : (
        children
    );
}
